import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithTimeout from './baseQueryWithTimeout';
import { getPetPhotoPath } from '../utils/mwEndpointUtils';
import { legacyPolicyNumberHandler } from '../helpers/paymentHelper';

const getPetBaseUrl = (isV3ApiEnabled) => (isV3ApiEnabled ? '/api/v3/pet' : '/api/pet');
const getPetHeaders = (auth0Token, isV3ApiEnabled) => (isV3ApiEnabled ? { customAuthToken: auth0Token } : {});

export const petApi = createApi({
  reducerPath: 'petApi',
  baseQuery: baseQueryWithTimeout,
  endpoints: (builder) => ({
    getPetPhoto: builder.query({
      query: ({ photoUrl, fullPolicyNumber, auth0Token }) => ({
        url: `/api/v3/pet/photo/${legacyPolicyNumberHandler(fullPolicyNumber)}/${getPetPhotoPath(photoUrl)}`,
        headers: { customAuthToken: auth0Token },
        responseHandler: (response) => response.blob()
      })
    }),
    uploadPetProfileImage: builder.mutation({
      query: ({ data, auth0Token, isV3ApiEnabled }) => ({
        url: `${getPetBaseUrl(isV3ApiEnabled)}/petImage`,
        method: 'POST',
        headers: getPetHeaders(auth0Token, isV3ApiEnabled),
        body: data
      })
    })
  })
});

export const { useGetPetPhotoQuery, useUploadPetProfileImageMutation } = petApi;
